module.exports = __webpack_public_path__ + "static/images/users.c3c4532a706edb5bd79cd8ea5fd620e7.svg";